/**
 * here it is assumed that the template are alrady loaded into dom 
 * as facet.js should be included before this file
 */	

var pageSearch = function(){
	
	var self = this;
	this.contentResultsTemplate = Rayban.templates.content_result_template;
	
	this.preprocess = function(){
		$(document).on("click","#pageNumbers .content-page-number", this.contentPageChangeHandler);
	};
	
	
	this.contentPageChangeHandler = function(event){
		window.scroll(0,$(".wcs-search-pages-title").offset().top);
		var newPageNumberContent = parseInt($(this).text());
		$(".content-page-number").removeClass("selected");
		$(this).addClass("selected");
		
		self.loadMoreContentPageResults(newPageNumberContent);
		
	};
	
	this.loadMoreContentPageResults = function(newPageNumberContent){
		var url=location.href;
		
		$(".wcs-loading-icon-wrapper-content").show();
		$(".wcs-loading-icon-wrapper").css("padding-bottom", "115px");
		$("#contentResultContainer #pageNumbers").addClass("disabled-page-nembers");
		var prams = {};
		var newPageNumber=parseInt($('#pageNumber').val())+1;
		if($("#pageType").val() =='SearchResults' && !isNaN(parseInt(getUrlParameter('pageSize'))) && 
				!isNaN(parseInt($('#defaultPageSize').val())) && parseInt($('#defaultPageSize').val())!==0){
			newPageNumber = getUrlParameter('pageSize')/parseInt($('#defaultPageSize').val())+1;
			newPageNumber =parseInt(newPageNumber);
		}
		$('#pageNumber').val(newPageNumber);
		if($("#pageType").val() =='SearchResults'){
			prams = {
					"viewMode" : $("#viewMode").val(),
					"searchType": $("#searchType").val(),
					"searchTermScope": $("#searchTermScope").val(),
					"sType": $("#sType").val(),
					"newpage": $("#newpage").val(),
					"facet": getUrlParameter('facet'),
					"clientSide": $("#clientSide").val(),
					"pageNumber":newPageNumber,
					"pageSize": $("#defaultPageSize").val(),
					"searchTerm" : getUrlParameter('searchTerm').split("+").join(" "),
					"pageNumberContent":newPageNumberContent,
					"pageSizeContent":10
			};
		}
						
		$.ajax({
			url: $('#nextContentPageUrl').val(),
			data: prams,
			traditional : true,
			success: function(resp){
				
				$(".wcs-loading-icon-wrapper-content").hide();
				$(".wcs-loading-icon-wrapper").css("padding-bottom", "0");
				$("#contentResultContainer #pageNumbers").removeClass("disabled-page-nembers");
				var data = $.parseJSON(resp);
				var contentData = $.parseJSON(data.contentdata);
				if(contentData && contentData!== null){
					contentData.paginationCount = self.getContentPageCount(contentData.totalContentCount, newPageNumberContent);
					self.loadContentResults(contentData, data.searchTerm);
				}
				if(data.nextContentPageURL){
					var nextContentPageUrl = data.nextContentPageURL.split("amp;").join("");
					$("#nextContentPageUrl").val(nextContentPageUrl);
				}
			}
		});
	};
	
	this.loadContentResults = function(contentData, searchTerm){
		
		$("#contentResultContainer").html(this.contentResultsTemplate(contentData));
		
        if(contentData.contents && contentData.contents.length > 0){
        	$('#contentResultContainer .content-result a, #contentResultContainer .content-result div').wrapInTag({
        		tag: 'strong',
        		words: searchTerm.split(" ")
        	});
        }
	};
	
	this.getContentPageCount = function(totalCount, newPageNumberContent){
		var paginationCount = [];
		var pageCount =Math.ceil(totalCount/10);
		for(var i=0; i<pageCount;i++){
			var pageNumberObj={};
			pageNumberObj.pageNumber = i+1;
			if(i === newPageNumberContent-1)
				pageNumberObj.className = "selected";
			
			paginationCount.push(pageNumberObj);
		}
		if(paginationCount.length >1){
			return paginationCount;
		}
	};
};

$(function(){
	window.pageSearchObj = new pageSearch();
	pageSearchObj.preprocess();
});
